import { storeLocationsService } from '@/services/api/storeLocations.service'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../queryKeys'

async function getStoreLocations(folderIds?: string[]) {
  const response = await storeLocationsService.getStoreLocations(folderIds)
  return response.data
}

type useGetStoreLocationsOptions = {
  enabled?: boolean
  folderIds?: string[]
}

export function useGetStoreLocations({
  enabled = true,
  folderIds,
}: useGetStoreLocationsOptions = {}) {
  return useQuery({
    queryKey: [QUERY_KEYS.storeLocations.getAll, { folderIds }],
    queryFn: () => getStoreLocations(folderIds),
    enabled,
  })
}
